<template>
  <!--    class="wrapper" -->
  <!-- class="toggled" -->
  <div class="wrapper">
     <div v-if="isShow===true">
      <div class="myMain main-panel" style="position: center; width:relative">
        <top-navbar class="topNavbar"></top-navbar>
        <top-navbar class="topNavbar"></top-navbar>
        <dashboard-content
          class="myMain"
          style="height: auto; margin: 0px"
          @click="toggleSidebar"
        >
        </dashboard-content>

        <content-footer class="footer" style="width: 100%"></content-footer>
      </div>
    </div>
    <div v-if="isShow===false">
      <div class="myMain main-panel" style="position: center; width: 100%">
        <top-navbar class="topNavbar"></top-navbar>

        <dashboard-content
          class="myMain"
          style="height: auto; margin: 0px"
          @click="toggleSidebar"

        >
        </dashboard-content>

        <content-footer class="footer" style="width: 100%"></content-footer>
      </div>
    </div>
  </div>
</template>
<style>
.myMain {
  background-color: #d4af37;
}

.topNavbar {
  background-color: #ffffff;

}

.all {
  background-color: #d4af37;
}

/*.footer {
  clear: both;
  position: relative;
  background-color: #d4af37;
  margin-top: 200px;
}
*/

.footer {
  background-color: #8A9A5B;
  margin: 0px;
  padding:0px;
  bottom:0px;
}


.wrapper {
  background-color: #d4af37;
 
  bottom:0px;
}


body {
  min-height: 100%;
  height: 100%;
  background-color: #d4af37;
}

</style>
<script>
import TopNavbar from './TopNavbar.vue'
import ContentFooter from './ContentFooter.vue'
import DashboardContent from './Content.vue'
import MobileMenu from './MobileMenu.vue'
export default {
  data(){
    return{
      authenticated: false,
      listMenus:[],
      isShow:false
    }
  },
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
  },
  mounted() {


  },
  methods: {
    toggleSidebar () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    }
  }
}
</script>
